/**
 *
 * @param {{ error: function(...arg: any[]): void }} logger
 * @param {string[]} methods
 * @return {{ error: function(...arg: any[]): void }}
 */
export const muteLogger = (logger, methods) => {
    const originalMethods = Object.fromEntries(methods.map((method) => [method, logger[method].bind(logger)]));
    const mutedMethod = () => {};
    // prettier-ignore
    // eslint-disable-next-line no-param-reassign
    methods.forEach((method) => { logger[method] = mutedMethod });

    return {
        ...logger,
        ...originalMethods
    };
};

